"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VFSceneCache = (function () {
    function VFSceneCache(scene) {
        this.scene = scene;
    }
    VFSceneCache.prototype.store = function () {
        var rootMesh = this.scene.model.getRoot();
        this.rootMeshState = {
            parent: rootMesh.parent,
            enabled: rootMesh.isEnabled(),
            absolutePosition: rootMesh.getAbsolutePosition().clone(),
            rotation: rootMesh.rotationQuaternion.clone(),
            scaling: rootMesh.scaling.clone(),
        };
        this.cachedCamera = this.scene.activeCamera.storeState();
    };
    VFSceneCache.prototype.restore = function () {
        var rootMesh = this.scene.model.getRoot();
        rootMesh.setParent(this.rootMeshState.parent);
        rootMesh.setEnabled(this.rootMeshState.enabled);
        rootMesh.setAbsolutePosition(this.rootMeshState.absolutePosition);
        rootMesh.rotationQuaternion = this.rootMeshState.rotation;
        rootMesh.scaling = this.rootMeshState.scaling;
        rootMesh.computeWorldMatrix(true);
        setTimeout(function () {
            this.cachedCamera.restoreState();
        }.bind(this));
    };
    return VFSceneCache;
}());
exports.default = VFSceneCache;
